/** The class given to each table's scroll container */
export const tableWrapperClassName = 'table-wrapper';


/** Wraps blog tables in a scroll container so wide tables don't overflow on narrow screens */
export default function wrapTables(element: HTMLElement) {
	// Iterate through every blog table
	for (const table of element.querySelectorAll('table')) {
		// Skip tables that were already wrapped
		if (table.parentElement?.classList.contains(tableWrapperClassName)) {
			continue;
		}
		
		
		// Move the table into a new wrapper
		const wrapper = document.createElement('div');
		wrapper.className = tableWrapperClassName;
		table.replaceWith(wrapper);
		wrapper.append(table);
	}
}
